<div #mainDiv_ll_model_payer_edit style="display: flex;">

  <div class="txtBold_16" style="clear: left; padding-left: 200px; padding-top: 0px;">
    <div class="wordBtnGroup">
      <div class="wordBtn14" (click)="submitChange()">Click Here to Save Changes!!</div>
    </div>
  </div>

  <div [hidden]="!bundle.showPayerEdit"
       [style.top.px]="bundle.outlineY"
       [style.left.px]="bundle.outlineX"
       [style.height.px]="bundle.outlineH"
       [style.width.px]="bundle.outlineW"
       style="position: absolute; background-color: transparent; border: none; outline: none; border-bottom: 1px solid rgb(160, 158, 158);">



    <!--<div class="txtBold_16" style="clear: left; padding-top: 5px;">
    <div class="wordBtnGroup">
      <div class="wordBtn16" (click)="submitChange()">Click Here to Save Changes!!</div>
    </div>
  </div>-->
    <!--PAYERINFORMATION-->
    <div style="position: absolute; overflow-y: auto;"
         [style.width.px]="bundle.spW"
         [style.height.px]="bundle.spH"
         [style.left.px]="bundle.spX"
         [style.top.px]="bundle.spY">
      <!-- Payer ID -->
      <div style="clear: left; padding-top: 0px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          LendingLinc Payer ID:
        </div>
        <div class="txtNorm12" style="float: left; padding-left: 5px;">
          {{bundle.PAYERID}}
        </div>
      </div>

      <!-- Payer Name -->
      <div style="clear: left; padding-top: 5px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          Payer:
        </div>
        <div class="txtNorm12" style="float: left; padding-left: 5px;">
          {{bundle.PAYERNAME}}
        </div>
      </div>

      <!-- Payer Parent -->
      <!--<div style="clear: left; padding-top: 5px;">
      <div class="txtBold_12" [style.width.px]="150" style="float: left;">
        Payer Parent:
      </div>
      <div class="txtNorm12" style="float: left; padding-left: 5px;">
        {{bundle.PAYERPARENT}}
      </div>
    </div>-->
      <!-- Software Vendor -->
      <div style="clear: left; padding-top: 5px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          Software Vendor:
        </div>
        <div class="txtNorm12" style="float: left; padding-left: 5px;">
          {{bundle.VENDERNAME}}
        </div>
      </div>

      <!-- Payer Eligible -->
      <div style="clear: left; padding-top: 5px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          Payer Eligible:
        </div>
        <div style="float: left; padding-left: 0px;">
          <div *ngFor="let ac_eligible of bundle.eligibleChoices" style="float: left; font-size: 13px; font-family: Arial; padding-right: 10px;">
            <label>
              <input type="radio"
                     name="eligiblegroup"
                     [value]="ac_eligible.code"
                     [checked]="ac_eligible.SELECTED"
                     (change)="selectAgeCap($event, 'PAYERELIGIBLEYN')">
              {{ac_eligible.choice}}
            </label>
          </div>
        </div>
      </div>

      <!-- Billed Age-Cap -->
      <div [style.width.px]="bundle.spW" style="clear: left; padding-top: 5px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          Billed Age-Cap:
        </div>
        <div style="float: left; padding-left: 0px;">
          <div *ngFor="let ac_billed of bundle.ageCapChoices_billed" style="float: left; font-size: 13px; font-family: Arial; padding-right: 10px;">
            <label>
              <input type="radio"
                     name="billedgroup"
                     [value]="ac_billed.code"
                     [checked]="ac_billed.SELECTED"
                     (change)="selectAgeCap($event, 'LIMIT_BILLED_AGECAPDAYS')">
              {{ac_billed.choice}}
            </label>
          </div>
        </div>
      </div>

      <!-- Billed Advance Rate -->
      <div [style.width.px]="bundle.spW" style="clear: left; padding-top: 0px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          Billed Advance Pct:
        </div>
        <div class="txtNorm13" style="float: left; padding-left: 0px;">
          <input type="text"
                 [value]="bundle.LIMIT_BILLEDADVANCE_PCT"
                 (input)="onInput($event, 'LIMIT_BILLEDADVANCE_PCT')"
                 (keyup)="onKeyUp($event, 'LIMIT_BILLEDADVANCE_PCT')"
                 style="width: 40px; height: 20px; font-size: 12px; font-family: Arial; text-align:right;">
        </div>
      </div>

      <!-- Unbilled Age-Cap -->
      <div [style.width.px]="bundle.spW" style="clear: left; padding-top: 5px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          Unbilled Age-Cap:
        </div>
        <div style="float: left; padding-left: 0px;">
          <div *ngFor="let ac_unbilled of bundle.ageCapChoices_unbilled" style="float: left; font-size: 13px; font-family: Arial; padding-right: 10px;">
            <label>
              <input type="radio"
                     name="unbilledgroup"
                     [value]="ac_unbilled.code"
                     [checked]="ac_unbilled.SELECTED"
                     (change)="selectAgeCap($event, 'LIMIT_UNBILLED_AGECAPDAYS')">
              {{ac_unbilled.choice}}
            </label>
          </div>
        </div>
      </div>

      <!-- Unbilled Advance Rate -->
      <div [style.width.px]="bundle.spW" style="clear: left; padding-top: 0px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          Unbilled Advance Pct:
        </div>
        <div class="txtNorm12" style="float: left; padding-left: 0px;">
          <input type="text"
                 [value]="bundle.LIMIT_UNBILLEDADVANCE_PCT"
                 (input)="onInput($event, 'LIMIT_UNBILLEDADVANCE_PCT')"
                 (keyup)="onKeyUp($event, 'LIMIT_UNBILLEDADVANCE_PCT')"
                 style="width: 40px; height: 20px; font-size: 12px; font-family: Arial; text-align:right;">
        </div>
      </div>

      <!-- Fixed ENV% -->
      <div [style.width.px]="bundle.spW" style="clear: left; padding-top: 5px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          Fixed ENV%
        </div>
        <div class="txtNorm12" style="float: left; padding-left: 0px;">
          <input type="text"
                 [value]="bundle.LIMIT_ENV_OVERRIDE_PCT"
                 (input)="onInput($event, 'LIMIT_ENV_OVERRIDE_PCT')"
                 (keyup)="onKeyUp($event, 'LIMIT_ENV_OVERRIDE_PCT')"
                 style="width: 40px; height: 20px; font-size: 12px; font-family: Arial; text-align:right;">
        </div>
        <div class="txtNorm11" style="float: left; padding-left: 20px;">
          Note: Dynamic vs Fixed Override ENV% set/determined at the model level
        </div>
      </div>

      <!-- ENV Calc Period -->
      <div [style.width.px]="bundle.spW" style="clear: left; padding-top: 5px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          ENV Calc Period:
        </div>
        <div style="float: left; padding-left: 0px;">
          <div *ngFor="let LIMIT_ENVCALCBUCKET_DAYS of bundle.LIMIT_ENVCALCBUCKET_DAYSChoices" style="float: left; font-size: 13px; font-family: Arial; padding-right: 10px;">
            <label>
              <input type="radio"
                     name="LIMIT_ENVCALCBUCKET_DAYS"
                     [value]="LIMIT_ENVCALCBUCKET_DAYS.code"
                     [checked]="LIMIT_ENVCALCBUCKET_DAYS.SELECTED"
                     (change)="selectLIMIT_ENVCALCBUCKET_DAYS($event)">
              {{LIMIT_ENVCALCBUCKET_DAYS.choice}}
            </label>
          </div>
        </div>
      </div>

      <!-- Reserve -->
      <div [style.width.px]="bundle.spW" style="clear: left; padding-top: 0px;">
        <div class="txtBold_12" [style.width.px]="150" style="float: left;">
          Reserve:
        </div>
        <div class="txtNorm12" style="float: left; padding-left: 0px;">
          <input type="text"
                 [value]="bundle.LIMIT_RESERVES_AMT"
                 (input)="onInput($event, 'LIMIT_RESERVES_AMT')"
                 (keyup)="onKeyUp($event, 'LIMIT_RESERVES_AMT')"
                 style="width: 75px; height: 20px; font-size: 12px; font-family: Arial; text-align:right;">
        </div>
      </div>
    </div>

    <!-- Payer Parent Choices Grid -->
    <!--<div style="position: absolute;"
         [style.width.px]="bundle.parentGridW"
         [style.left.px]="bundle.parentGridX"
         [style.top.px]="bundle.spY">
      <div class="txtBold_12" style="padding-bottom: 10px;">ACH Payer Parent:</div>
      <div #gridContainer style="overflow-y: auto;"
           [style.height.px]="bundle.spH - 30">
        <div style="display: grid; grid-template-columns: 1fr; gap: 0;">
          <div *ngFor="let payer of bundle.parentPayerArray; let i = index"
               [attr.data-sysid]="payer.payerParent_sysId"
               (click)="selectPayerParent(payer)"
               style="padding: 4px 10px; background-color: #f5f5f5; cursor: pointer; font-size: 13px; font-family: Arial; border: 1px solid #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 20px;"
               [style.background-color]="payer.payerParent_sysId === bundle.PAYERPARENT_SYSID ? '#90ee90' : '#f5f5f5'">
            {{payer.realParentName}}
          </div>
        </div>
      </div>
    </div>-->


  </div>


</div>
